// @ts-nocheck
import { useEffect, useRef } from "react";

export default () => {
    const isFirstRenderRef = useRef(true);

    useEffect(() => {
        isFirstRenderRef.current = false;
    }, []);

    return isFirstRenderRef.current;
};
